import styled from "styled-components"

export const ErrorLabel = styled.span`
  color: #ff4b4b;
  font-size: 12px;
`
